import * as React from 'react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { HeaderCredits } from '@/components/common/HeaderCredits';
import upgradeIcon from '@/assets/images/svg/upgrade_icon.svg';
import { ACCOUNT_BILLING_CREDITS_PATH } from '@/routes/paths';

interface SidebarUpgradeProps {
  isCollapsed: boolean;
}

export const SidebarUpgrade: React.FC<SidebarUpgradeProps> = ({ isCollapsed }) => {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    navigate(ACCOUNT_BILLING_CREDITS_PATH);
  };

  return (
    <div
      className={clsx(
        'flex w-full flex-col gap-[clamp(8px,2dvh,23px)] xl:gap-[23px]',
        'mb-[clamp(4px,0.8dvh,16px)] xl:mb-4',
        !isCollapsed && ['pl-4 pr-[42px] xl:px-0', 'xl:mx-auto xl:w-[186px]'],
        isCollapsed && 'px-[7px]'
      )}
    >
      <HeaderCredits isCollapsed={isCollapsed} className='w-full text-black' />

      {/* Upgrade Button */}
      <Button
        onClick={handleUpgradeClick}
        variant='sidebar-upgrade'
        className={clsx(
          'h-[clamp(36px,6dvh,49px)] w-full xl:h-[49px]',
          'rounded-[30px]', // Enforce 30px radius
          // Collapsed: Center content (icon)
          isCollapsed ? 'justify-center px-0' : ''
        )}
      >
        <img
          src={upgradeIcon}
          alt='Upgrade'
          className={clsx(
            'size-6',
            // Expanded: Absolute left
            !isCollapsed && 'absolute left-[9px]',
            // Collapsed: Static centered
            isCollapsed && 'static'
          )}
        />
        {/* Only show text if NOT collapsed */}
        {!isCollapsed && 'Upgrade'}
      </Button>
    </div>
  );
};
